import { render, staticRenderFns } from "./ModalNewAsset.vue?vue&type=template&id=3089f3b0&"
import script from "./ModalNewAsset.vue?vue&type=script&lang=js&"
export * from "./ModalNewAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports